import "./Navbar.scss";
import { useState } from "react";
import { NavHashLink } from "react-router-hash-link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const waOpen = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=6281212356556&text=Halo+Mario,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Summarecon%20Tangerang?%20http://marketingrumahtangerang.id/&type=phone_number&app_absent=0",
      "_blank",
    );
  };

  return (
    <>
      <div className="top-bar">
        Info Properti Summarecon Tangerang dibuat Oleh PT Asia Rumah Utama -{" "}
        <a
          href="https://api.whatsapp.com/send/?phone=6281212356556&text=Halo+Mario,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20Summarecon%20Tangerang?%20http://marketingrumahtangerang.id/&type=phone_number&app_absent=0"
          className="number-phone"
          target="_blank"
          rel="noopener noreferrer"
        >
          +6281212356556
        </a>
      </div>
      <nav className="navbar">
        <div className="navbar-container">
          <a
            href="/"
            className="navbar-logo"
            style={{
              display: "flex",
              flexDirection: "column",
              textDecoration: "none",
              color: "#08325c",
              alignItems: "flex-start",
            }}
          >
            <span
              style={{
                fontSize: "1.2rem",
                fontWeight: "bold",
                lineHeight: "1.2",
              }}
            >
              Summarecon Tangerang
            </span>
            <span
              style={{
                fontSize: "0.8rem",
                fontWeight: "normal",
                color: "#32312d",
              }}
            >
              Mitra Pemasaran
            </span>
          </a>
          <ul className={isMenuOpen ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <NavHashLink smooth to="/#about" className="nav-links">
                About Us
              </NavHashLink>
            </li>
            <li className="nav-item">
              <NavHashLink smooth to="/#promo" className="nav-links">
                Promo
              </NavHashLink>
            </li>
            <li className="nav-item">
              <NavHashLink smooth to="/#rumah" className="nav-links">
                Residentials
              </NavHashLink>
            </li>
            <li className="nav-item">
              <NavHashLink smooth to="/#lokasi" className="nav-links">
                Lokasi
              </NavHashLink>
            </li>
          </ul>
          <div className="menu-icon" onClick={toggleMenu}>
            <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
          </div>
          <button onClick={waOpen} className="btn-navbar">
            Contact Us
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
